export const orderItems = {
    orderItem: []
}

export const mutations = {
    setOrderItemData(state, item) {
        state.orderItem = item
    }
}